






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import firstInstance from './firstInstance.vue'
import secondInstance from './secondInstance.vue'
const SECOND_TITLE = '新建二审任务'
const authList = [
	{
		title: '新建一审任务',
		authStr: 'addLawsuit:firstInstance',
		code: '1',
	},
	{
		title: SECOND_TITLE,
		authStr: 'addLawsuit:secondInstance',
		code: '2',
	},
]
@Component({
	components: {
		firstInstance,
		secondInstance,
	},
})
export default class addTask extends Vue {
	private active: any = '1'

	@Prop()
	public data!: any

	private get tabList() {
		if (this.$route.params && this.$route.params.relatedOrderNo) {
			// 由详情新建二审
			return authList.filter(
				(item: any) => item.title === SECOND_TITLE && this.$auth(item.authStr)
			)
		} else {
			return authList.filter((item: any) => this.$auth(item.authStr))
		}
	}

	private toggle(i: any) {
		this.active = i
	}

	private setPlan() {
		this.$emit('setPlan')
	}

	private setData(key: string, val: any) {
		this.$emit('setData', key, val)
	}

	private created() {
		this.active = this.tabList[0] && this.tabList[0].code
	}
}
